import { Places } from 'src/Constants'
import AnaliseKeys from '../analise.keys'

export class AnaliseFormKeys extends AnaliseKeys {
    get place() {
        return Places.mcAnaliseForm
    }
}
export default AnaliseFormKeys
